import React from 'react';
import PropTypes from 'prop-types';
import { WarningIcon } from '../Icons';
import { ButtonLink } from '../Dashboard/Button';
import { ErrorWrapper, ErrorBox, MessageContainer } from './styles';

var Error = function Error(_ref) {
  var Message = _ref.Message,
      goto = _ref.goto;
  return React.createElement(
    ErrorWrapper,
    null,
    React.createElement(
      ErrorBox,
      null,
      React.createElement(WarningIcon, null),
      React.createElement(
        MessageContainer,
        null,
        Message ? React.createElement(Message, null) : React.createElement(
          'h3',
          null,
          'Something went wrong'
        )
      ),
      goto ? React.createElement(
        'p',
        null,
        React.createElement(
          ButtonLink,
          { href: goto.url },
          goto.label
        )
      ) : null
    )
  );
};

Error.displayName = 'Error';
Error.propTypes = process.env.NODE_ENV !== "production" ? {
  goto: PropTypes.shape({
    url: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  })
} : {};

export default Error;